export default __webpack_public_path__ + "static/media/XpatsoAndroidApp.41239eb8.png";